import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import chances, { chancesSaga } from './chances';
import chanceBases, { chanceBasesSaga } from './chanceBases';
import chance, { chanceSaga } from './chance';
import chanceComments, { chanceCommentsSaga } from './chanceComments';
import salesHistory, { salesHistorySaga } from './sales-history';
import salesEstimate, { salesEstimateSaga } from './sales-estimate';
import buysEstimate, { buysEstimateSaga } from './buys-estimate';
import chanceCosts, { chanceCostsSaga } from './chanceCosts';
import chanceEstimateCosts, {
  chanceEstimateCostsSaga,
} from './chanceEstimateCosts';
import chanceEstimates, { chanceEstimatesSaga } from './chanceEstimates';
import chanceEstimate, { chanceEstimateSaga } from './chanceEstimate';
import purchaseQuoteFiles, {
  purchaseQuoteFilesSaga,
} from './purchaseQuoteFiles';
import chanceFiles, { chanceFilesSaga } from './chanceFiles';
import chanceTechFiles, { chanceTechFilesSaga } from './chanceTechFiles';
import purchaseOrderFiles, {
  purchaseOrderFilesSaga,
} from './purchaseOrderFiles';
import projectTechs, { projectTechsSaga } from './projectTechs';
import reqTechs, { ReqTechsSaga } from './techReqs';
import planTechs, { PlanTechsSaga } from './techPlans';
import midTechs, { MidTechsSaga } from './techMids';
import rsltTechs, { rsltTechsSaga } from './techRslts';
import tech, { techSaga } from './tech';
import techPlan, { techPlanSaga } from './techPlan';
import techMid, { techMidSaga } from './techMid';
import techRslt, { techRsltSaga } from './techRslt';
import techFiles, { techFilesSaga } from './techFiles';
import chanceFails, { chanceFailsSaga } from './chance-fails';
import orderFiles, { orderFilesSaga } from './order-files';

const chanceModule = combineReducers({
  chanceComments,
  salesHistory,
  chances,
  chanceBases,
  chance,
  chanceFiles,
  chanceTechFiles,
  purchaseOrderFiles,
  chanceCosts,
  chanceEstimateCosts,
  chanceEstimates,
  chanceEstimate,
  purchaseQuoteFiles,
  projectTechs,
  tech,
  techPlan,
  techMid,
  techFiles,
  techRslt,
  reqTechs,
  planTechs,
  midTechs,
  rsltTechs,
  salesEstimate,
  buysEstimate,
  chanceFails,
  orderFiles,
});

export function* chanceModuleSaga() {
  yield all([
    chancesSaga(),
    chanceBasesSaga(),
    chanceSaga(),
    chanceCommentsSaga(),
    salesHistorySaga(),
    chanceFilesSaga(),
    chanceTechFilesSaga(),
    purchaseOrderFilesSaga(),
    chanceCostsSaga(),
    chanceEstimateCostsSaga(),
    chanceEstimatesSaga(),
    chanceEstimateSaga(),
    purchaseQuoteFilesSaga(),
    projectTechsSaga(),
    techSaga(),
    techPlanSaga(),
    techMidSaga(),
    techFilesSaga(),
    techRsltSaga(),
    ReqTechsSaga(),
    PlanTechsSaga(),
    MidTechsSaga(),
    rsltTechsSaga(),
    salesEstimateSaga(),
    buysEstimateSaga(),
    chanceFailsSaga(),
    orderFilesSaga(),
  ]);
}

export default chanceModule;
